const libraries: 'places'[] = ['places'];

export default libraries;
